import { TextField } from '@mui/material';
import customAxios from '../../../utils/customAxios';
import { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import 'react-toastify/dist/ReactToastify.css';

import '../../../scss/Components/_modal.scss';
import { GlobalVariables } from '../../../globalVar';
import { useTranslationHook } from '../../../hooks/UseTranslationHook';
import { getToast } from '../../../utils/toastConfig';

function ModalAddManufacturers(props) {
  const { 
    newStr,
    manufacturerStr,
    manufacturerDescriptionStr,
    manufacturerNameStr,
    saveStr
    
  } = useTranslationHook();

  const [name, setName] = useState('');
  const [description, setDescription] = useState('');

  function hide() {
    props.onHide();
    getToast({ status: 'success', title: 'Equipo creado exitosamente en la base de datos.' });
    props.getManufacturers();
  }
  
  //Create Manufacturers
  function createManufacturer(event) {
    event.preventDefault();
    customAxios
      .post(`${GlobalVariables.getURL()}manufacturers/create`, {
        name: name,
        description: description,
      }, {
        headers: {
          'Authorization': 'bearer ' + localStorage.getItem('token')
        }
      })
      .then(
        (response) => {
          if (response.status === 200) {
            hide();
          }
          
        },
        (error) => {
          console.log(error);
          getToast({ status: 'error', title: 'Error al crear equipo. Vuelve a intentarlo.' });
        }
      );
  }

  return (
    <Modal
      {...props}
      size='lg'
      aria-labelledby='contained-modal-title-vcenter'
      backdropClassName='modal-backdrop'
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id='contained-modal-title-vcenter'>
        {newStr + " " + manufacturerStr.charAt(0).toLowerCase() + manufacturerStr.slice(1)}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form id='manufacturers-form' onSubmit={createManufacturer}>
          <div className='row'>
            <div className='col-md-12'>
              <TextField
                sx={{ width: '100%' }}
                label={manufacturerNameStr}
                type='text'
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>
          </div>

          <br/>

          <div className='row'>
            <div className='col-md-12'>
              <TextField
                sx={{ width: '100%' }}
                label={manufacturerDescriptionStr}
                type='text'
                multiline
                rows={3}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <button type='submit' form='manufacturers-form' className='save-modal-button'>
          {saveStr}
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default ModalAddManufacturers;
